/* Kuk bakım rehberi (sop/politika-blog.json 49, 53): Paylaş (Web Share API; yoksa bağlantı panoya kopyalanır,
   2 sn 'Bağlantı kopyalandı') ve hafif YouTube gömme (poster; dokununca youtube-nocookie iframe, otomatik oynatma yok).
   DAHA FAZLA GÖSTER assets/kuk-facets.js'te. */
(() => {
  if (window.kukBlog) return;
  window.kukBlog = true;
  document.addEventListener('click', async (e) => {
    const paylas = e.target.closest('[data-kuk-paylas]');
    if (paylas) {
      const adres = window.location.href.split('#')[0];
      if (navigator.share) {
        try { await navigator.share({ title: paylas.dataset.baslik, url: adres }); } catch (hata) { /* vazgeçildi */ }
        return;
      }
      const bildirim = document.querySelector('[data-paylas-bildirim]');
      try {
        await navigator.clipboard.writeText(adres);
        if (bildirim) {
          bildirim.textContent = paylas.dataset.kopyalandi;
          setTimeout(() => { bildirim.textContent = ''; }, 2000);
        }
      } catch (hata) { /* pano izni yok */ }
      return;
    }
    const video = e.target.closest('[data-kuk-video]');
    if (video) {
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(video.dataset.kukVideo)}?autoplay=1&rel=0`;
      iframe.title = video.dataset.baslik || '';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      video.replaceWith(iframe);
    }
  });
})();
